import type { SessionType } from "@/util/types/globalTypes";

export function isValidCompiledSession(compiled: any): boolean {
  return !!(
    compiled?.userId?._id &&
    compiled?.userId?.company?.name &&
    compiled?.userId?.memberships?.length
  );
}

export function transformCompiledSession(compiled: any): SessionType {
  return {
    user: {
      ...compiled.userId,
      id: compiled.userId._id,
      emailVerified: compiled.userId.emailVerified || null,
    },
    sessionToken: compiled.sessionToken,
    expires: compiled.expires,
    userId: compiled.userId._id,
  };
}
